import { render, staticRenderFns } from "./AccountProfile.vue?vue&type=template&id=2b5ca09c&"
import script from "./AccountProfile.vue?vue&type=script&lang=js&"
export * from "./AccountProfile.vue?vue&type=script&lang=js&"
import style0 from "./AccountProfile.vue?vue&type=style&index=0&lang=stylus&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports